import React from "react";
import styled from "styled-components";

const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
`;

const SkeletonCard = styled.div`
  border: 2px solid #eee;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  animation: pulse 1.5s ease-in-out infinite;

  @keyframes pulse {
    0% {
      background: #f5f5f5;
    }
    50% {
      background: #eeeeee;
    }
    100% {
      background: #f5f5f5;
    }
  }
`;

const SkeletonLine = styled.div`
  height: 12px;
  background: #ddd;
  border-radius: 4px;
  margin-bottom: 10px;
  animation: shimmer 1.5s ease-in-out infinite;

  @keyframes shimmer {
    0% {
      background: #ddd;
    }
    50% {
      background: #e8e8e8;
    }
    100% {
      background: #ddd;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }

  &.title {
    height: 14px;
    margin-bottom: 12px;
  }

  &.short {
    width: 70%;
  }
`;

const AddressSkeleton = ({ count = 2 }) => {
  return (
    <SkeletonWrapper>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonCard key={index}>
          <SkeletonLine className="title" />
          <SkeletonLine />
          <SkeletonLine className="short" />
          <SkeletonLine className="short" />
        </SkeletonCard>
      ))}
    </SkeletonWrapper>
  );
};

export default AddressSkeleton;
